// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SidePanel_Wrapper__2x8yr","Container":"SidePanel_Container__310fs","Open":"SidePanel_Open__3cMYo"};